/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React from 'react';

import Svg from 'svg'


export default function (props)
{
  return (
    <Svg viewBox="0 0 24 24" {...props}><defs/><rect width="24" height="24" className="none"/><polygon points="20 16.5 12 21 4 16.5 4 7.5 12 3 20 7.5 20 16.5" className="black-line-20"/></Svg>
  );
}
